import { observer } from "mobx-react-lite";
import React from "react";
import { commaSeperated, getDisplayDate } from "../../utils/functions";
import MoneyValueContainer from "../MoneyValueContainer/MoneyValueContainer";

const InstrumentsValueContainer = ({
  data,
  addDash,
  isInterest,
  unitBased,
}) => {
  return (
    <div className="instr_value_container_outside">
      <div className="instr_value_title_container">
        <h2 className="instr_value_title">
          More details for{" "}
          <span className="dataFont">
            {Number(data?.instrument?.quantity)?.toLocaleString("hi-IN")}
          </span>{" "}
          units
        </h2>
        <p className="instr_value_sub_title">
          Inception Date <span>{getDisplayDate(data.inceptiondate)}</span>
        </p>
      </div>
      {unitBased ? (
        <div className="inst_value_money_cont">
          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Avg. Buy Price"}
            amount={`${commaSeperated(data.average_buy_price)} `}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            title={"CMP"}
            hasPadding
            amount={`${commaSeperated(data.cmp)} `}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Invested Value"}
            amount={`${commaSeperated(
              data?.investmentreturn?.invested_value?.value
            )} `}
            unitType={data?.investmentreturn?.invested_value?.value_type}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={!isInterest ? "Div/Others" : "Int/Others"}
            amount={`${commaSeperated(data?.div_others?.value)} `}
            unitType={data?.div_others?.value_type}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Unrealised Gains (%)"}
            amtPercentage={`${data?.investmentreturn?.unrealised_gain?.percentage}`}
            amount={`${commaSeperated(
              data?.investmentreturn?.unrealised_gain?.amount?.value
            )}`}
            unitType={
              data?.investmentreturn?.unrealised_gain?.amount?.value_type
            }
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Realised Gain"}
            amount={`${commaSeperated(
              data?.investmentreturn?.realised_gain?.amount?.value
            )} `}
            unitType={data?.investmentreturn?.realised_gain?.amount?.value_type}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Principal Paid"}
            amount={`${commaSeperated(data?.principal_paid_amt?.value)} `}
            unitType={data?.principal_paid_amt?.value_type}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Par Value"}
            amount={`${commaSeperated(data?.par_value_amt?.value)} `}
            unitType={data?.par_value_amt?.value_type}
          />
        </div>
      ) : (
        <div className="inst_value_money_count2">
          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Invested Value"}
            amount={`${commaSeperated(
              data?.investmentreturn?.invested_value?.value
            )} `}
            unitType={data?.investmentreturn?.invested_value?.value_type}
          />
          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Principal Paid"}
            amount={`${commaSeperated(data?.principal_paid_amt?.value)} `}
            unitType={data?.principal_paid_amt?.value_type}
          />
          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Par Value"}
            amount={`${commaSeperated(data?.par_value_amt?.value)}`}
            unitType={data?.par_value_amt?.value_type}
          />
          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Int/Others"}
            amount={`${commaSeperated(data?.div_others?.value)} `}
            unitType={data?.div_others?.value_type}
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            //   hasPadding
            title={"Unrealised Gains (%)"}
            amtPercentage={`${data?.investmentreturn?.unrealised_gain?.percentage}`}
            amount={`${commaSeperated(
              data?.investmentreturn?.unrealised_gain?.amount?.value
            )}`}
            unitType={
              data?.investmentreturn?.unrealised_gain?.amount?.value_type
            }
          />

          <MoneyValueContainer
            addDash={addDash ? true : false}
            hasPadding
            title={"Realised Gain"}
            amount={`${commaSeperated(
              data?.investmentreturn?.realised_gain?.amount?.value
            )} `}
            unitType={data?.investmentreturn?.realised_gain?.amount?.value_type}
          />
        </div>
      )}
    </div>
  );
};

export default observer(InstrumentsValueContainer);
